/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ShivaGNVertSecuredConfiguration {
  rootUrl: string = '/web';
}

/**
 * Parameters for `ShivaGNVertSecuredModule.forRoot()`
 */
export interface ShivaGNVertSecuredConfigurationParams {
  rootUrl?: string;
}
